export const caretDoubleHorizontal16 = "M6 12.1L1.9 8 6 3.9zm4 0L14.1 8 10 3.9z";
